
export const VERSION = '5.7.1'; // Update this manually on each release


